<template>
  <div class="form-group mb10">
    <div class="form-control">
      <label>{{ $t("top_line.summary") }}</label>
      <textarea id="top-line-summary" name="summary" class="input-ui"
                v-model.trim="localValue"
                @change="onTextAreaBlur"></textarea>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      summary: 'articleTopLine/summary'
    }),
    localValue: {
      get() {
        return this.summary;
      },
      set(newValue) {
        this.refreshSummary(newValue);
      }
    }
  },
  methods: {
    ...mapActions({
      refreshSummary: 'articleTopLine/refreshSummary'
    }),
    onTextAreaBlur (e) {
      if (e.target.style.height) {
        e.target.style.height = null;
      }

      this.$emit('update');
    }
  }
}
</script>